// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".breadcrumbs-container__breadcrumbs--text{font-size:16px;font-weight:700;line-height:20px}.breadcrumbs-container__breadcrumbs--text:hover{-webkit-text-decoration:underline;text-decoration:underline}.v-breadcrumbs__item--disabled{color:var(--v-primary-base)!important}.v-breadcrumbs li:nth-child(2n){padding:0 4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
